export const TEXTS = {
  DURATION: 'Длительность',
  TIME: 'Время выхода',
  DURATION_HELP: 'Мин. 00:00:01',
  TIME_HELP: 'Введите время в формате чч:мм',
};
